// import SettingsIcon from '@material-ui/icons/SettingsTwoTone';
import React from 'react';

import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { MenuItemType } from 'components/layout/header/headerTypes';
import MenuLink from 'components/layout/header/MenuLink';
import { staticDispatch, useSelector } from 'reduxState/store';
import { openSettings } from 'reduxState/userSettings/userSettingsReducer';

function WalletSettingsMenuItem() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  if (!walletAddress) {
    return null;
  }

  const handleOpenSettings = () => staticDispatch(openSettings());

  return (
    <MenuLink
      onClick={handleOpenSettings}
      title={<MaterialSymbol icon="settings" fontSize="small" />}
      css={{ lineHeight: 0 }}
      isTopMenu={true}
    />
  );
}

const walletSettingsItem: MenuItemType = {
  type: 'MenuBox',
  Component: WalletSettingsMenuItem,
};

export default walletSettingsItem;
